import React, {useEffect, useState} from 'react';
import PersonalAreaAddAddress from './PersonalAreaAddAddress';
import PersonalAreaEditAddress from './PersonalAreaEditAddress';
import ShowAddress from './ShowAddress/ShowAddress';
import { useUserContext } from "../../../context/UserContext";
import './PersonalAreaAddress.scss';

const PersonalAreaAddress = () => {
    const [editedAddress, setEditedAddress] = useState(null);
    const [addAddress, setAddAddress] = useState(null);
    const {user: { addresses }} = useUserContext();
    useEffect(() => {
        if(addresses.length === 0){
            setAddAddress(true);
        }
    }, [addresses])

    if (editedAddress) return <PersonalAreaEditAddress address={editedAddress} setEditedAddress={setEditedAddress} />;
    if (addAddress) return <PersonalAreaAddAddress setAddAddress={setAddAddress} />;

    return <ShowAddress setEditedAddress={setEditedAddress} setAddAddress={setAddAddress} />;
};

export default PersonalAreaAddress;
